module.exports = __webpack_public_path__ + "static/media/worldHigh3.5d2a4a3f.svg";